var map = {
	"./gym.svg": "88Ee",
	"./list.svg": "5HGL",
	"./lock.svg": "JQup",
	"./user.svg": "k/OS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oDra";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons nonrecursive ./node_modules/svg-sprite-loader/lib/loader.js .*\.svg$
// module id = oDra
// module chunks = 0